import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import config from '../../config';
import { headers } from "../../token";
import UpdateQuotation from "./QuotationUpdate";
import QuotationViews from "./QuotationView";
import html2pdf from 'html2pdf.js';
import ReactDOM from 'react-dom';
import DeletedQuotation from "./DeleteQuotation";
import vAdminformat from '../../adminFormat';

import CustomDateRangePicker from '../CustomDateRangePicker';
import Swal from "sweetalert2";

const server_backend = config.API_URL;

const QuotationHistory = ({ email }) => {
    const [quotationList, setQuotationList] = useState([]);
    const [isUpdating, setIsUpdating] = useState(false);
    const [filtersEnabled, setFiltersEnabled] = useState(false);
    const [filterBy, setFilterBy] = useState("name");
    const [filterStatus, setFilterStatus] = useState(0);
    const [filterValue, setFilterValue] = useState(null);
    const [selectedFilter, setSelectedFilter] = useState("");
    const [viewBQuotation, setViewBQuotation] = useState(false);
    const [currentQuotation, setCurrentQuotation] = useState(0);
    const [selectedDayRange, setSelectedDayRange] = useState({
        from: null,
        to: null,
    });

    const [statusQuot, setStatusQuot] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 50;

    useEffect(() => {
        const getQuotations = async () => {
            try {
                const response = await axios.get(`${server_backend}/quotations/list`, headers);

                if (response.data.RES_CODE === "00") {
                    const data = response.data.RES_RESULT;
                    setQuotationList(data);
                }
            } catch (error) {
                console.log("Unexpected error, please check")
            }
        }
        getQuotations();
    }, []);

     useEffect(() => {
            if (filtersEnabled) {
    
                //console.log("Unexpected error, please check")
                FilterCustomer();
            }
        }, [selectedDayRange]);

    const getQuotations = async () => {

        try {
            const response = await axios.get(`${server_backend}/quotations/list`, headers);

            if (response.data.RES_CODE === "00") {
                const data = response.data.RES_RESULT;
                setQuotationList(data);
            }
        } catch (error) {
            console.log("Unexpected error, please check")
        }
    }

    //with the aim of automatically refreshing the quote
    /*   setTimeout(() => {
          getQuotations()
      }, 5000);
   */

    useEffect(() => {
        const getStatusQuotation = async () => {
            try {
                const response = await axios.get(`${server_backend}/system/transactions/status/quotation`, headers);
                if (response.data.RES_CODE === "00") {
                    setStatusQuot(response.data.RES_RESULT);
                }
            } catch (error) {
                console.log("Unexpected error, please check")
            }
        }
        getStatusQuotation();
    }, []);

    const handleFiltersToggle = () => {
        setFiltersEnabled(!filtersEnabled);
    };

    const handleFilterByChange = (e) => {
        setFilterBy(e.target.value);
        const value = e.target.value;
        FilterCustomer(value);
    };

    const handleFilterStatusChange = (e) => {
        setFilterStatus(e.target.value);
    };

    const handleFilterValueChange = (e) => {
        setFilterValue(e.target.value);

    };

    const handleColumnClick = (filterValue) => {
        if (filtersEnabled) {
            setSelectedFilter(filterValue);
            handleFilterByChange({ target: { value: filterValue } });
        }

    };

    const FilterCustomer = async () => {
        try {
            const response = await axios.get(`${server_backend}/quotations/search?user_transaction=${email}&findby=${filterBy}&findfor=${filterValue}&est_id=${filterStatus}&startDate=${selectedDayRange.from}&endDate=${selectedDayRange.to}`, headers);
            //console.log("Unexpected error, please check")
            setQuotationList(response.data.RES_RESULT);
        } catch (error) {
            console.log("Unexpected error, please check")
        }
    };

    useEffect(() => {
        if (filtersEnabled) {
            FilterCustomer();
        }
    }, [filterBy, filterStatus, filterValue]);

    const showViewQuotation = () => {
        setViewBQuotation(true);
    }

    const CloseViewQuotation = () => {
        setViewBQuotation(false);
    }

    const ShowModalUpdate = () => {
        setIsUpdating(true);
    }

    const CloseModalUpdate = () => {
        setIsUpdating(false);
    }

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = quotationList.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(quotationList.length / itemsPerPage);

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };


    const handleDateChange = (dates) => {
        setSelectedDayRange({
            from: dates.from,
            to: dates.to,
        });
    };

    const DeleteQuot = async (onQuotationID) => {
      
        //setLoading(true);

        //console.log("Unexpected error, please check")

        Swal.fire({
            icon: 'warning',
            title: 'Alert',
            text: "Are you sure you want to cancel this Order?",
            showCancelButton: true,
            confirmButtonText: 'Accept',
            cancelButtonText: "Cancel"
        }).then(async (result) => {
            if (result.isConfirmed) {

                try {
                    const response = await axios.post(`${server_backend}/quotations/update`, {
                        id: onQuotationID,
                        est_id: 6
                    }, headers);
                    if (response.data.RES_CODE === "00") {
                        Swal.fire({
                            icon: 'success',
                            title: 'Canceled Successfully',
                            showConfirmButton: false,
                            timer: 2000
                        });
                        getQuotations();
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'Error updating Order',
                            showConfirmButton: false,
                            timer: 2000
                        });
                    }
                } catch (error) {
                    const responseData = error.response.data.RES_MESSAGE;
                    //console.log("Unexpected error, please check")
                    Swal.fire({
                        icon: 'error',
                        title: responseData,
                        showConfirmButton: false,
                        timer: 3000
                    });
                }
            }
        }
        )
    };

    return (
        <div className="page-content" data-simplebar-track="secondary" data-simplebar="init" style={{ overflow: "auto" }}>
            {viewBQuotation ? (
                /*   <ViewCustomer email={email} customerID={currentCustomer} CloseViewCustomer={CloseViewCustomer} /> */
                <QuotationViews QuotationID={currentQuotation} getQuotations={getQuotations} CloseViewQuotation={CloseViewQuotation} />
            ) : (
                isUpdating ? (
                    <UpdateQuotation onClose={CloseModalUpdate} onQuotationID={currentQuotation} getQuotations={getQuotations} />
                ) : (
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                    <h4 className="mb-sm-0">History</h4>
                                    <div className="page-title-right">
                                        <ol className="breadcrumb m-0">
                                            <li className="breadcrumb-item"><Link>Instant Quote</Link></li>
                                            <li className="breadcrumb-item active">List</li>
                                        </ol>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-lg-12">
                                <div className="card" id="tasksList">
                                    <div className="card-header border-0">
                                        <div className="d-flex align-items-center">
                                            <h5 className="card-title mb-0 flex-grow-1">All Instant Quote </h5>
                                            <div className="col-xxl-1 col-sm-2" style={{ paddingRight: "2px" }}>
                                                <button type="button" className="btn btn-primary w-100" onClick={handleFiltersToggle}>
                                                    <i className="ri-equalizer-fill me-1 align-bottom"></i> Filters
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    {filtersEnabled && (
                                        <div className="card-body border border-dashed border-end-0 border-start-0">
                                            <div className="row g-3">
                                                <div className="col-4">
                                                    <div className="input-light">
                                                        <select
                                                            className="form-control custom-select-style"
                                                            name="choices-single-default"
                                                            disabled={!filtersEnabled}
                                                            value={filterBy}
                                                            onChange={handleFilterByChange}
                                                        >
                                                            <option value="">All</option>
                                                            <option value="quot_ID">ID</option>
                                                            <option value="fullname">Customer name</option>
                                                            <option value="email">Email</option>
                                                            <option value="phone">Phone</option>
                                                            <option value="city">City</option>
                                                        </select>

                                                    </div>
                                                </div>
                                                <div className="col-4">
                                                    <div className="input-light">
                                                        <select
                                                            className="form-control custom-select-style"
                                                            name="choices-single-default"
                                                            id="idFilterStatus"
                                                            disabled={!filtersEnabled}
                                                            onChange={handleFilterStatusChange}
                                                        >
                                                            <option value={0}>All</option>
                                                            {statusQuot.map((status) => (
                                                                <option key={status.est_ID} value={status.est_ID}>{status.name}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-4">
                                                    <CustomDateRangePicker onDateChange={handleDateChange} />
                                                </div>
                                                <div className="col-12">
                                                    <div className="search-box">
                                                        <input
                                                            type="text"
                                                            className="form-control search"
                                                            placeholder="Search for tasks or something..."
                                                            disabled={!filtersEnabled}
                                                            onChange={handleFilterValueChange}
                                                        />
                                                        <i className="ri-search-line search-icon"></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    <div className="card-body">
                                        <div
                                            className="table-responsive table-card mb-4"
                                            style={{ minHeight: "60vh", display: "flex", flexDirection: "column" }}
                                        >
                                            <table className="table align-middle table-nowrap mb-0" id="tasksTable">
                                                <thead className="table-light text-muted">
                                                    <tr>
                                                        <th className="th-hover" onClick={() => handleColumnClick("quot_ID")}>ID</th>
                                                        <th className="th-hover" onClick={() => handleColumnClick("fullname")}>Full Name</th>
                                                        <th className="th-hover" onClick={() => handleColumnClick("phone")}>Phone</th>

                                                        <th className="th-hover" onClick={() => handleColumnClick("date_created")}>Dated Created</th>
                                                        <th className="th-hover" onClick={() => handleColumnClick("city")}>User Created</th>
                                                        <th className="th-hover" onClick={() => handleColumnClick("status")}> Status</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody className="list form-check-all">
                                                    {currentItems.map((Quotations_L) => (
                                                        <tr key={Quotations_L.quot_ID}>
                                                            <td className="id">
                                                                <Link to="#" className="fw-medium link-primary">
                                                                    {Quotations_L.quot_ID}
                                                                </Link>
                                                            </td>
                                                            <td className="fullname">{Quotations_L.fullname}</td>
                                                            <td className="phone">{Quotations_L.phone}</td>

                                                            <td className="date">{vAdminformat.FormatDate(Quotations_L.date_created)}</td>
                                                            <td className="user_created">{Quotations_L.user_created}</td>
                                                            <td className="status">
                                                                <span className={`${Quotations_L.est_ID === 4 ? "badge badge-soft-warning text-uppercase"
                                                                    : (
                                                                        Quotations_L.est_ID === 5 ? "badge badge-soft-success text-uppercase"
                                                                            : (
                                                                                Quotations_L.est_ID === 6 ? "badge badge-soft-danger text-uppercase" : (
                                                                                    Quotations_L.est_ID === 13 ? "badge badge-label bg-danger" : null
                                                                                )
                                                                            )
                                                                    )} text-uppercase`}>
                                                                    {Quotations_L.status_name}
                                                                </span>

                                                            </td>
                                                            <td className="due_date">
                                                                <ul className="list-inline hstack gap-2 mb-0 fs-5">
                                                                    <li className="list-inline-item" >
                                                                        <Link className="text-danger d-inline-block remove-item-btn" onClick={() => {
                                                                            setCurrentQuotation(Quotations_L.quot_ID);
                                                                            showViewQuotation()
                                                                        }}
                                                                            data-toggle="tooltip"
                                                                            data-placement="top" title="View ">
                                                                            <i className="ri-eye-fill align-bottom me-2 text-muted"></i>
                                                                        </Link>
                                                                    </li>

                                                                    {/*                         <li className="list-inline-item edit">
                                                                        <Link
                                                                            type="button"
                                                                            onClick={() => downloadInvoice(Quotations_L)}
                                                                            className="text-primary d-inline-block edit-item-btn"
                                                                        >
                                                                            <i className="ri-download-2-line"></i>
                                                                        </Link>
                                                                    </li> */}
                                                                  {/*   <li className="list-inline-item edit">
                                                                        <Link
                                                                            type="button"
                                                                            onClick={() => {
                                                                                ShowModalUpdate();
                                                                                setCurrentQuotation(Quotations_L.quot_ID);
                                                                            }}
                                                                            className="text-primary d-inline-block edit-item-btn"
                                                                            data-toggle="tooltip"
                                                                            data-placement="top" title="Update " >
                                                                            <i className="ri-pencil-fill fs-16"></i>
                                                                        </Link>
                                                                    </li>

                                                                    <li className="list-inline-item" >
                                                                        <Link className="text-danger d-inline-block remove-item-btn" onClick={() => {
                                                                            DeleteQuot(Quotations_L.quot_ID)
                                                                            //DeletedQuotation(Quotations_L.quot_ID, getQuotations)
                                                                        }} data-toggle="tooltip"
                                                                            data-placement="top" title="Delete ">
                                                                            <i className="ri-delete-bin-5-fill fs-16"></i>
                                                                        </Link>
                                                                    </li> */}
                                                                </ul>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                        <div className="row justify-content-between align-items-center">
                                            <div className="col-auto me-3">
                                                <p className="text-muted mb-sm-0">Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, quotationList.length)} of {quotationList.length} entries</p>
                                            </div>
                                            <div className="col-auto">
                                                <ul className="pagination pagination-separated pagination-sm justify-content-end mb-sm-0">
                                                    <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                                        <a href="#" onClick={() => handlePageChange(currentPage - 1)} className="page-link">←</a>
                                                    </li>
                                                    {Array.from({ length: totalPages }, (_, index) => (
                                                        <li key={index + 1} className={`page-item ${currentPage === index + 1 ? 'active' : ''}`}>
                                                            <a href="#" onClick={() => handlePageChange(index + 1)} className="page-link">{index + 1}</a>
                                                        </li>
                                                    ))}
                                                    <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                                        <a href="#" onClick={() => handlePageChange(currentPage + 1)} className="page-link">→</a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="row g-0 text-center text-sm-start">
                                            <div className="col-sm-6">
                                            </div>
                                            <div className="col-sm-6">
                                                <div className="pagination-block pagination pagination-separated justify-content-center justify-content-sm-end mb-sm-0">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            )}
        </div>
    );
};

export default QuotationHistory;
